<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            class="animated fadeIn">
            <div slot="header">
              <i class="fa fa-home"></i><strong> Datos CSV</strong>
              <div class="card-header-actions">
              </div>
            </div>
            <b-row>
              <b-col lg="6">
                <b-card>
                  <b-form-group label="Reporte">
                    <b-form-select
                      v-model="$v.form.report.$model"
                      :state="$v.form.report.$dirty ? !$v.form.report.$error : null"
                      :options="report_type">
                    </b-form-select>
                  </b-form-group>

                  <b-form-group label="Rango de fecha">
                    <date-range-picker
                      ref="picker"
                      v-model="dateRange"
                      :startDate="startDate"
                      :endDate="endDate"
                      :locale-data="locale"
                      :ranges="ranges"
                      opens="right"
                      @update="updateValues"
                      :autoApply="autoApply"
                      :showWeekNumbers="showWeekNumbers"
                    >
                      <div slot="input" slot-scope="picker" style="min-width: 350px;">
                        <i class="fa fa-calendar text-primary"></i>
                         {{ picker.startDate | moment }} - {{ picker.endDate | moment }}
                    </div>
                    </date-range-picker>
                  </b-form-group>

<!--                  <b-form-group>-->
<!--                    <label>Fecha inicial</label>-->
<!--                    <b-form-input-->
<!--                      type="date"-->
<!--                      id="waybill_date"-->
<!--                      v-model="$v.form.from.$model"-->
<!--                      :state="$v.form.from.$dirty ? !$v.form.from.$error : null"-->
<!--                    ></b-form-input>-->
<!--                    <div class="error text-danger mt-1" v-if="!$v.form.from.minValue"></div>-->
<!--                    <b-form-invalid-feedback id="input-1-live-feedback">-->
<!--                      Campo obligatorio: no puede tener una antiguedad de mas de 2 meses.-->
<!--                    </b-form-invalid-feedback>-->
<!--                  </b-form-group>-->

<!--                  <b-form-group>-->
<!--                    <label>Fecha final</label>-->
<!--                    <b-form-input-->
<!--                      type="date"-->
<!--                      id="waybill_date"-->
<!--                      v-model="$v.form.to.$model"-->
<!--                      :state="$v.form.to.$dirty ? !$v.form.to.$error : null"-->
<!--                    ></b-form-input>-->
<!--                    <b-form-invalid-feedback id="input-1-live-feedback">-->
<!--                      Fecha no puede superar el día de hoy.-->
<!--                    </b-form-invalid-feedback>-->

<!--                  </b-form-group>-->
                  <b-button @click="onSubmit" variant="primary" class="float-right" :disabled="$v.form.$invalid || loading == true">
                    <div v-if="loading == false">Descargar</div>
                    <div v-if="loading" class="align-middle"><b-spinner v-if="loading == true" small type="grow"></b-spinner>Cargando...</div>
                  </b-button>
                </b-card>
              </b-col>
              <b-col lg="6">

              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import numeral from 'numeral';
  import locales from 'numeral/locales'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'

  import { validationMixin } from 'vuelidate'
  import { required, maxValue, minValue } from 'vuelidate/lib/validators'

  numeral.locale('es');
  moment.locale('es');
  window.axios = require('axios');



  export default {
    name: 'Excel',
    components: {
      DateRangePicker
    },
    created () {

    },
    beforeMount () {
      this.getReports()
    },
    data () {
      return {
        loading: false,
        showWeekNumbers: true,
        autoApply: true,
        now: moment(new Date()).format(),
        report_type: [],
        form: {
          report: null,
          from: null,
          to: null
        },
        dateRange: null,
        startDate: new Date() - 7,
        endDate: new Date(),
        locale: {
            direction: 'ltr', //direction of text
            format: 'DD-MM-YYYY', //fomart of the dates displayed
            separator: ' - ', //separator between the two ranges
            applyLabel: 'Ok',
            cancelLabel: 'Cancelar',
            weekLabel: 'S',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
            monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
            firstDay: 1 //ISO first day of week - see moment documenations for details
        },
        ranges: {
          // 'Hoy': [moment(), moment()],
          // 'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Este mes': [moment().startOf('month'), moment().endOf('month')],
          '1ra Quincena': [moment().startOf('month'), moment().startOf('month').add(14, 'days')],
          '2da Quincena': [moment().startOf('month').add(15, 'days'), moment().endOf('month')],
          'Este año': [moment().startOf('year'), moment().endOf('year')],
          'Semana Pasada': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
          'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        }
      }
    },
    validations: {
      form: {
        report: {
          required
        },
        // from: {
        //   required,
        //   minValue: value => value > moment(new Date()).subtract(2, 'month').format()
        // },
        // to: {
        //   required,
        //   maxValue: value => value < moment(new Date()).format()
        // }
      }
    },
    computed: {
      url () {
        return 'reports/' + this.form.report;
      }
    },
    filters: {
        moment: function (date) {
          return moment(date).format('DD-MM-YYYY');
        },
        decimal (value) {
          return numeral(value).format('0,0.00');
        }
      },
    methods: {
      getReports () {
        this.$axios.get ('/reports/get_csv_reports/')
          .then(res => {
            // console.log(res)
            const data = res.data.data;
            const reports = [];
            for (let key in data) {
              const report = data[key];
              reports.push(report)
            }
            this.report_type = reports
          })
          .catch(error => console.log(errors))
      },
      updateValues (a) {
        this.form.from = moment(a.startDate).format('YYYY-MM-DD');
        this.form.to = moment(a.endDate).format('YYYY-MM-DD')
      },
      onSubmit() {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        console.log('a')
        this.loading = true
        this.downloadWithAxios(1,1)



      },
      forceFileDownload(response, a){
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.form.report + this.form.from + 'a' + this.form.to+'.csv') //or any other extension
        document.body.appendChild(link)
        link.click()
      },

      downloadWithAxios(a, b){
        this.$axios({
          method: 'post',
          url: this.url,
          responseType: 'arraybuffer',
          data: {
            start_date: this.form.from,
            end_date: this.form.to
          }
        },

        )
        .then(response => {

          this.forceFileDownload(response, b)
          this.loading = false;
          this.form.report = null
          this.form.from = null
          this.form.to = null
          this.$v.$reset();



        })
        .catch(() => {
          this.loading = false;
          this.form.report = null
          this.form.from = null
          this.form.to = null
          this.$v.$reset();
          console.log('error occured')
        })
      },
    },
  };
</script>

<style scoped>

</style>
